import Axios from "axios";
import { localAPI } from "../api/local";
import * as userConstants from "../constants/userConstants.js";
import history from "../config/history";
import { errorHandler } from "./errorHandler";
import axios from "axios";

Axios.defaults.withCredentials = true;

export const registerUser =
  ({ name, email, password }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: userConstants.USER_REGISTER_REQUEST,
        payload: {
          email,
        },
      });
      const { data } = await localAPI.post(
        "/api/signup/register",
        {
          name,
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );
      await dispatch({
        type: userConstants.USER_REGISTER_SUCCESS,
        payload: data,
      });

      history.push("/confirmation/activation/progress");
      // dispatch({
      //   type: userConstants.USER_SIGNIN_SUCCESS,
      //   payload: data,
      // });

      // save the user data and token
      // localStorage.setItem("userInfo", JSON.stringify(data));
      // reload current page
      // history.go(0);
    } catch (error) {
      // dispatch({
      //   type: userConstants.USER_REGISTER_FAIL,
      //   payload:
      //     error.response && error.response.data.error
      //       ? error.response.data.error
      //       : error.message,
      // });

      // register user, thisis direct because errors are shown on registering panel
      errorHandler(userConstants.USER_REGISTER_FAIL, error, true, dispatch);
    }
  };
export const activateUser = (token) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_ACTIVATION_REQUEST,
      payload: token,
    });
    const { data } = await localAPI.post(
      "/api/signup/activate",
      { token },
      {
        withCredentials: true,
      }
    );
    dispatch({
      type: userConstants.USER_ACTIVATION_SUCCESS,
      payload: data,
    });
    dispatch({
      type: userConstants.USER_SIGNIN_SUCCESS,
      payload: data,
    });

    // save the user data and token
    localStorage.setItem("userInfo", JSON.stringify(data));
    // reload current page
    history.push("/confirmation/activation/success");
  } catch (error) {
    errorHandler(
      userConstants.USER_ACTIVATION_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.push(`/confirmation/activation/fail?message=${errMessage}`);
      }
    );
  }
  // const { data } = await Axios.post('http://localhost:3030/api/signup/register', {
  //   firstName,
  //   lastName,
  //   email,
  //   phone,
  //   password
  // });

  // if(data.success){
  //   dispatch({ type: userConstants.USER_REGISTER_SUCCESS, payload: data });
  //   dispatch({ type: userConstants.USER_SIGNIN_SUCCESS, payload: data });
  // }
};

export const loginUser =
  ({ email = null, password }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: userConstants.USER_SIGNIN_REQUEST,
        payload: {
          email,
        },
      });
      const { data } = await localAPI.post(
        "/api/signup/login",
        {
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );
      dispatch({
        type: userConstants.USER_SIGNIN_SUCCESS,
        payload: data,
      });

      // save to localstorage as string
      localStorage.setItem("userInfo", JSON.stringify(data));

      // redirect to appropriate page
      // if (window.location.pathname === "/") {
      //   history.push("/videos");
      // } else {
      //   history.go(0);
      // }
      if (history.location.pathname.includes("confirmation")) {
        history.push("/");
      } else {
        history.go(0);
      }
    } catch (error) {
      // dispatch({
      //   type: userConstants.USER_SIGNIN_FAIL,
      //   payload:
      //     error.response && error.response.data
      //       ? error.response.data.error
      //       : error.message,
      // });

      errorHandler(userConstants.USER_SIGNIN_FAIL, error, true, dispatch);
    }
  };

export const signOut =
  (reload = true) =>
  async (dispatch) => {
    localStorage.removeItem("userInfo");
    dispatch({
      type: userConstants.USER_SIGNOUT,
    });
    if (reload) {
      if (history.location.pathname.includes("confirmation")) {
        history.push("/");
      } else {
        history.go(0);
      }
    }
  };

export const checkUser = () => (dispatch) => {
  const userData = localStorage.getItem("userInfo");
  dispatch({
    type: userConstants.CHECK_USER,
    payload: userData,
  });
};

export const googleLogin = (token) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_SIGNIN_REQUEST,
    });
    const data = await localAPI.post(
      "/api/signup/google",
      {
        token,
      },
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: userConstants.USER_SIGNIN_SUCCESS,
      payload: data,
    });
    await localStorage.setItem("userInfo", JSON.stringify(data.data));

    if (history.location.pathname.includes("confirmation")) {
      history.push("/");
    } else {
      history.go(0);
    }
  } catch (error) {
    // dispatch({
    //   type: userConstants.USER_SIGNIN_FAIL,
    //   payload:
    //     error.response && error.response.data.error
    //       ? error.response.data.error
    //       : error.message,
    // });
    errorHandler(userConstants.USER_SIGNIN_FAIL, error, true, dispatch);
  }
};

export const accountDetailsUser = () => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_ACCOUNT_DETAILS_REQUEST,
    });

    const data = await localAPI.get("/api/users/details");


    dispatch({
      type: userConstants.USER_ACCOUNT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(
      userConstants.USER_ACCOUNT_DETAILS_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const subscriptionDetailsUser = () => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_SUBSCRIPTION_DETAILS_REQUEST,
    });

    const data = await localAPI.get("/api/users/subscription-details");

    dispatch({
      type: userConstants.USER_SUBSCRIPTION_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(
      userConstants.USER_SUBSCRIPTION_DETAILS_FAIL,
      error,
      false,
      dispatch
    );
  }
};


export const watchlistUser = () => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_WATCHLIST_REQUEST,
    });

    const data = await localAPI.get("/api/users/watchlist");
    dispatch({
      type: userConstants.USER_WATCHLIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(userConstants.USER_WATCHLIST_FAIL, error, false, dispatch);
  }
};

export const pwdResetMailUser = (userEmail) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_PWD_RESET_MAIL_REQUEST,
    });
    const { data } = await localAPI.post(
      "/api/pwdReset",
      {
        userEmail,
      },
      {
        withCredentials: true,
      }
    );
    dispatch({
      type: userConstants.USER_PWD_RESET_MAIL_SUCCESS,
      payload: data,
    });

    history.push("/confirmation/pwdReset/progress");
  } catch (error) {
    errorHandler(
      userConstants.USER_PWD_RESET_MAIL_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const pwdResetCheckUser = (token, userId) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_PWD_RESET_CHECK_REQUEST,
      payload: {
        token,
        userId,
      },
    });
    const { data } = await localAPI.post(
      "/api/pwdReset/tokenCheck",
      { token, userId },
      {
        withCredentials: true,
      }
    );
    dispatch({
      type: userConstants.USER_PWD_RESET_CHECK_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(
      userConstants.USER_PWD_RESET_CHECK_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.push(`/confirmation/pwdReset/fail?message=${errMessage}`);
      }
    );
  }
};

export const pwdResetUser = (token, userId, password) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_PWD_RESET_REQUEST,
      payload: {
        token,
        userId,
      },
    });
    const { data } = await localAPI.post(
      "/api/pwdReset/pwdReset",
      { token, userId, password },
      {
        withCredentials: true,
      }
    );
    dispatch({
      type: userConstants.USER_PWD_RESET_SUCCESS,
      payload: data,
    });

    history.push("/confirmation/pwdReset/success");
  } catch (error) {
    errorHandler(
      userConstants.USER_PWD_RESET_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.push(`/confirmation/pwdReset/fail?message=${errMessage}`);
      }
    );
  }
};

export const unsubscribeUserSettings = () => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_REQUEST,
    });
    const { data } = await localAPI.post("/api/users/unsubscribeDailyMail", {
      withCredentials: true,
    });
    dispatch({
      type: userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_SUCCESS,
      payload: data,
    });

    history.go(0);
  } catch (error) {
    errorHandler(
      userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.go(0);
      }
    );
  }
};

export const resubscribeUserSettings = () => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_REQUEST,
    });
    const { data } = await localAPI.post("/api/users/subscribeDailyMail", {
      withCredentials: true,
    });
    dispatch({
      type: userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_SUCCESS,
      payload: data,
    });

    history.go(0);
  } catch (error) {
    errorHandler(
      userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.go(0);
      }
    );
  }
};

export const unsubscribeUser = (token, userId) => async (dispatch) => {
  try {
    dispatch({
      type: userConstants.USER_UNSUBSCRIBE_MAIL_REQUEST,
      payload: {
        token,
        userId,
      },
    });
    const { data } = await localAPI.post(
      "/api/videos/unsubscribeDailyMail",
      { token, userId },
      {
        withCredentials: true,
      }
    );
    dispatch({
      type: userConstants.USER_UNSUBSCRIBE_MAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(
      userConstants.USER_UNSUBSCRIBE_MAIL_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const loggedInAndPremiumCheckUser = () => async (dispatch) => {
  // dispatch({
  //   type: userConstants.USER_LOGGEDIN_REQUEST,
  // });

  await localAPI
    .get("/api/users/isloggedin")
    .then(async () => {
      // dispatch({
      //   type: userConstants.USER_PREMIUM_REQUEST,
      // });

      await localAPI
        .get("/api/users/ispremium")
        .then(async () => {
          dispatch({
            type: userConstants.USER_LOGGEDIN_SUCCESS_PREMIUM_SUCCESS,
            payload: {
              isLoggedIn: true,
              isPremium: true,
            },
          });
        })
        .catch((error) => {
          if (
            error.response.data.error ==
            "Sorry you cannot access this, premium content"
          ) {

            dispatch({
              type: userConstants.USER_LOGGEDIN_SUCCESS_PREMIUM_FAIL,
              payload: {
                isLoggedIn: true,
                isPremium: false,
              },
            });
          } else {
            errorHandler(
              userConstants.USER_PREMIUM_FAIL,
              error,
              false,
              dispatch
            );
          }
        });
    })
    .catch((error) => {
      localStorage.removeItem("userInfo");

      dispatch({
        type: userConstants.USER_LOGGEDIN_FAIL_PREMIUM_FAIL,
        payload: {
          isLoggedIn: false,
          isPremium: false,
        },
      });
    });
};

export const getUserCountry = (ip) => async (dispatch) => {
  try {

    dispatch({
      type: userConstants.USER_COUNTRY_REQUEST,
      payload: {
        ip
      },
    });

    const res = await axios.get(`${process.env.REACT_APP_LOCAL_API_URL}/api/get-location/`, {
      withCredentials: false
    });
    console.log(res);
    dispatch({
      type: userConstants.USER_COUNTRY_SUCCESS,
      payload: {
        locationData: res.data
      }
    });

  } catch (error) {
    errorHandler(
      userConstants.USER_COUNTRY_FAIL,
      error,
      false,
      dispatch
    );
  }
};

// check user logged in
// succesful
// check user premium
// succesfull
// return loggedIn true, premium true
// error
// check if error was about premium
// if about premium
// return loggedIn true premium false
// else
// pass to errorHandler
// error
// check if error for login
// if error for login
// return loggedin true premium false
// else
// pass to error handler

// export const detailsUser = (userId) => async (dispatch, getState) => {
//   dispatch({ type: userConstants.USER_DETAILS_REQUEST, payload: userId });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.get(`/api/users/${userId}`, {
//       headers: { Authorization: `Bearer ${userInfo?.token}` },
//     });
//     dispatch({ type: userConstants.USER_DETAILS_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_DETAILS_FAIL, payload: message });
//   }
// };

// export const updateUserProfile = (user) => async (dispatch, getState) => {
//   dispatch({ type: userConstants.USER_UPDATE_PROFILE_REQUEST, payload: user });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.put(`/api/users/profile`, user, {
//       headers: { Authorization: `Bearer ${userInfo.token}` },
//     });
//     dispatch({ type: userConstants.USER_UPDATE_PROFILE_SUCCESS, payload: data });
//     dispatch({ type: userConstants.USER_SIGNIN_SUCCESS, payload: data });
//     localStorage.setItem('userInfo', JSON.stringify(data));
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_UPDATE_PROFILE_FAIL, payload: message });
//   }
// };
// export const updateUser = (user) => async (dispatch, getState) => {
//   dispatch({ type: userConstants.USER_UPDATE_PROFILE_REQUEST, payload: user });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.put(`/api/users/${user._id}`, user, {
//       headers: { Authorization: `Bearer ${userInfo.token}` },
//     });
//     dispatch({ type: userConstants.USER_UPDATE_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_UPDATE_FAIL, payload: message });
//   }
// };
// export const listUsers = () => async (dispatch, getState) => {
//   dispatch({ type: userConstants.USER_LIST_REQUEST });
//   try {
//     const {
//       userSignin: { userInfo },
//     } = getState();
//     const { data } = await Axios.get('/api/users', {
//       headers: {
//         Authorization: `Bearer ${userInfo.token}`,
//       },
//     });
//     dispatch({ type: userConstants.USER_LIST_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_LIST_FAIL, payload: message });
//   }
// };
// export const deleteUser = (userId) => async (dispatch, getState) => {
//   dispatch({ type: userConstants.USER_DELETE_REQUEST, payload: userId });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.delete(`/api/users/${userId}`, {
//       headers: { Authorization: `Bearer ${userInfo.token}` },
//     });
//     dispatch({ type: userConstants.USER_DELETE_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_DELETE_FAIL, payload: message });
//   }
// };
// export const listTopSellers = () => async (dispatch) => {
//   dispatch({ type: userConstants.USER_TOPSELLERS_LIST_REQUEST });
//   try {
//     const { data } = await Axios.get('/api/users/top-sellers');
//     dispatch({ type: userConstants.USER_TOPSELLERS_LIST_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.error
//         ? error.response.data.error
//         : error.message;
//     dispatch({ type: userConstants.USER_TOPSELLERS_LIST_FAIL, payload: message });
//   }
// };
